export const TOOLTIP_AUTO_HIDE_TIMEOUT: number = 2000;
export const MAP_DEVICE_PIXEL_RATIO: number = 2;
